import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { selectAppShowBackgroundImage } from 'store/app/selectors';
import { ImageBackground } from 'expo-image';
import { View } from 'react-native';

const AppBackdropImage = require('assets/backdrop.jpg');
export const AppBackgroundImage = () => {
  const showAppBackgroundImage = useSelector(selectAppShowBackgroundImage);

  if (!showAppBackgroundImage) {
    return null;
  }

  return (
    <View
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        backgroundColor: 'white',
      }}
    >
      <ImageBackground
        contentFit="cover"
        contentPosition="center"
        style={{
          opacity: 0.2,
          flex: 1,
        }}
        source={AppBackdropImage}
      />
    </View>
  );
};
